module.exports = __webpack_public_path__ + "b5af92f89f316038d5965ff45dbe7f37.glb";